import { render } from "./PlayerView.vue?vue&type=template&id=7f2449ac&scoped=true"
import script from "./PlayerView.vue?vue&type=script&lang=js"
export * from "./PlayerView.vue?vue&type=script&lang=js"

import "./PlayerView.vue?vue&type=style&index=0&id=7f2449ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2449ac"]])

export default __exports__